$(() => {
    $('.js-catalog-hit-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="catalog__button catalog__button--prev slick-arrow" aria-label="Предыдущий слайд" type="button"><svg class="icon catalog__button-icon" width="45" height="45"><use xlink:href="svg-symbols.svg#arrow-left"></use></svg></button>',
        nextArrow: '<button class="catalog__button catalog__button--next slick-arrow" aria-label="Следующий слайд" type="button"><svg class="icon catalog__button-icon" width="45" height="45"><use xlink:href="svg-symbols.svg#arrow-right"></use></svg></button>',
        responsive: [
            {
                breakpoint: 1365,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                }
            }
        ]
    });
});


// WEBPACK FOOTER //
// ./markup/components/main/catalog/catalog.js